import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Nav } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

const AdminConsoleLayout = ({ auth, children }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || auth.role !== 'admin') {
      history.push('/');
    }
  }, [auth, history]);

  if (!auth || auth.role !== 'admin') {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Admin Console | Elliot Koss</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Container style={{ paddingTop: '100px', paddingBottom: '2rem' }}>
        <Row className="mb-4">
          <Col>
            <h1>Admin Console</h1>
            <p className="text-muted">Manage users, AI models, and system configuration</p>
          </Col>
        </Row>

        <Row>
          <Col md={3} className="mb-4">
            <Card>
              <Card.Body className="p-0">
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/console/users" exact>
                      Users
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/admin/console/models" exact>
                      AI Models
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Body>
            </Card>
          </Col>

          <Col md={9}>
            {children}
          </Col>
        </Row>
      </Container>
    </>
  );
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminConsoleLayout);
